module.exports = __webpack_public_path__ + "img/BLOCK.98ac88b9.svg";